import { CONSULTATIONS_CODES } from "./consultationsData";

export const consultationTitle = {
  [CONSULTATIONS_CODES.initial_screening]: "Getting to know you",
  [CONSULTATIONS_CODES.initial_intake]: "Detailed assessment",
} as const;
